export interface ClubSearchData {
  Abbreviation: string;
  AllowMembers: boolean;
  AltName: string;
  ApprovedToCreateLeagues: boolean;
  ApprovedToCreateTournaments: boolean;
  City: string;
  ClubGUID: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  CurrPage: number;
  IsActiveMember: number;
  LeagueCount: number;
  Logo: string;
  MemberCount: number;
  PageCount: number;
  Ratings_Activate: boolean;
  RecordCount: number;
  RowNumber: number;
  SportID: string;
  StateAbbreviation: string;
  StateTitle: string;
  StreetAddress: string;
  Title: string;
  TourneyCount: number;
  Venue: string;
  Zip: string;
  mng: number;
  slug?: string;
}

export interface PlayerClubsData {
  uuid: string;
  title: string;
  abbreviation: string;
  approvedTournaments: boolean;
  approvedLeagues: boolean;
  countryId: number;
  stateId: number;
  timezoneId: number;
  localizationId: number;
  currencyId: number;
  additionalInfo: string;
  description: string;
  slug: string;
  memberCount: string;
  totalTournaments: string;
  totalLeagues: string;
  totalTeamLeagues: string;
  contactFormShowOnPage: boolean | null;
  aboutUsShowOnPage: boolean;
  featuredServicesShowOnPage: boolean | null;
  featuredPlansShowOnPage: boolean;
  testimonialsShowOnPage: boolean;
  imagesShowOnPage: boolean;
  ctaShowOnPage: boolean | null;
  additionalInfoTitle: string | null;
  themeId: string;
  featuredServicesTitle: string | null;
  featuredServicesSubtitle: string | null;
  publicPbMissionStatementDescription: string | null;
  highlightsTitle: string;
  highlightsSubtitle: string;
  featuredMembershipPlansPricingTitle: string | null;
  featuredMembershipPlansPricingSubtitle: string | null;
  publicPbMissionStatementTitleNonThemed: string;
  publicPbMissionStatementTitleThemed: string;
  descriptionTitleNonThemed: string;
  descriptionTitleThemed: string;
  showContactFormMap: boolean | null;
  schedulerShowOnPage: boolean;
  testimonialsTitle: string | null;
  testimonialsSubtitle: string | null;
  organizationTagline: string | null;
  facebook: string | null;
  twitter: string | null;
  youtube: string;
  instagram: string | null;
  snapchat: string | null;
  tiktok: string | null;
  canBeAffiliatedTo: boolean;
  showMembers: boolean;
  showTournaments: boolean;
  showClinics: boolean;
  showLeagues: boolean;
  showTeamLeagues: boolean;
  uniqueSellingPropositionsTitle: string | null;
  uniqueSellingPropositionsSubtitle: string | null;
  uniqueSellingPropositionsShowOnPage: boolean | null;
  primaryLocation: PlayerClubDataLocation;
  stateInfo: PlayerClubsDataState;
  countryInfo: PlayerClubsDataCountry;
  organizationLogos: PlayerClubsDataLogo[];
  currencyInfo: PlayerClubsDataCurrency;
  localizationInfo: PlayerClubsDataLocalization;
  isFavourite: boolean | null;
  agreedToAllWaivers: boolean;
}

export interface Organization {
  organization: PlayerClubsData;
  expired: boolean;
}

export interface PlayerClubDataLocation {
  uuid: string;
  uuidCopiedFrom: string;
  moduleFor: number;
  moduleUuid: string;
  surfaceTypeId: number;
  playAreaTypeId: number;
  netTypeId: number;
  isPrimary: boolean;
  venue: string;
  altName: string;
  streetAddress: string;
  countryId: number;
  stateId: number;
  city: string;
  zip: string;
  ballUsed: string;
  ballUrl: string;
  parkingInformation: string;
  isParkingFee: boolean;
  numberOfCourts: number;
  latitude: number;
  longitude: number;
  dateCreated: string;
  createdByFullName: string;
  dateUpdated: string | null;
  updatedByFullName: string;
  dateDisabled: string | null;
  disabledByFullName: string;
  usePrintSpooler: boolean;
  locationIdInt: string;
  geniusSportsCourts: boolean;
  venueGeniusId: string;
  dateApproved: string | null;
  description: string;
  email: string;
  isFeeToPay: boolean;
  isLight: boolean;
  isOpenPlay: boolean;
  title: string;
  numberOfCourtsIndoor: string;
  numberOfCourtsOutdoor: string;
  phone: string;
  phoneAreaCode: string;
  phoneCountryId: string;
  url: string;
  lighting: boolean;
  facilityCategory: number;
}

export interface PlayerClubsDataState {
  id: string;
  abbreviation: string;
  title: string;
  countryId: number;
  isEnabled: boolean;
}

export interface PlayerClubsDataCountry {
  abbreviation: string;
  id: string;
  internationalCountryCallingCode: string;
  title: string;
  stateTitle: string;
  zipCodeTitle: string;
  systemTextNumberId: string;
  abbreviation2Digit: string;
  displayOrder: string;
  isEnabled: boolean;
  regionType: string;
}

export interface PlayerClubsDataLogo {
  uuid: string;
  moduleFor: string;
  moduleUuid: string;
  url: string;
  isPrimary: boolean;
  dateCreated: string;
  dateUpdated: string;
  dateDisabled: string | null;
}

export interface PlayerClubsDataCurrency {
  id: string;
  title: string;
  abbreviation: string;
  isEnabled: boolean;
  currencyCode: string;
  symbol: string;
  symbolPosition: string;
  thousandSeparator: string;
  decimalSeparator: string;
  decimalPlaces: number;
}

export interface PlayerClubsDataLocalization {
  id: string;
  family: string;
  tagFormat: string;
  tagTranslations: string;
  fullVariant: string;
  abbreviation: string;
  flag: string;
  actualLanguage: string;
  isEnabled: boolean;
  displayOrder: number;
}

export interface RenderedPlayerClubsData {
  uuid: string;
  slug: string;
  title: string;
  totalTournaments: string;
  totalLeagues: string;
  venue: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  memberCount: string;
  logo: string;
  agreedToAllWaivers: boolean;
  isFavourite: boolean | null;
  showToPublic?: boolean;
  expired?: boolean;
}

export interface SearchClubResponse {
  Abbreviation: string;
  AllowMembers: boolean;
  AltName: string;
  ApprovedToCreateLeagues: boolean;
  ApprovedToCreateTournaments: boolean;
  City: string;
  ClubGUID: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  CurrPage: number;
  IsActiveMember: number;
  LeagueCount: number;
  Logo: string;
  MemberCount: number;
  ModuleID?: string;
  PageCount: number;
  Ratings_Activate: boolean;
  RecordCount: number;
  RowNumber: number;
  SponsorLogo?: string;
  SponsorTitle?: string;
  SportID: string;
  StateAbbreviation: string;
  StateTitle: string;
  StreetAddress: string;
  Tagline?: string;
  Title: string;
  TitleSponsorLogo: string;
  TitleSponsorTagline: string;
  TitleSponsorTitle: string;
  TitleSponsorURL: string;
  TourneyCount: number;
  URL?: string;
  Venue: string;
  Zip: string;
  mng: number;
  slug: string;
}

export enum ClubTypes {
  Managing = 'Manage',
  MemberOf = 'MemberOf',
  Favorites = 'Favorites',
}

export const clubTypeMap: Record<string, ClubTypes> = {
  memberof: ClubTypes.MemberOf,
  manage: ClubTypes.Managing,
  favorites: ClubTypes.Favorites,
};
